import { ICustomField } from 'wisestep-api';

export const checkIfRequiredField = (
  fields: ICustomField[] | null,
  fieldName: string,
  requiredDefault: boolean
): boolean => {
  const field = fields?.find((field) => field.name === fieldName);
  return field ? field.required ?? requiredDefault : requiredDefault;
};
